export enum LetterSizeOptionType {
  NO = 'NO',
  FIT = 'FIT',
  STRETCH = 'STRETCH',
}
